/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Share_DoneInputs */

const en_rd_share_done = /** @type {(inputs: Rd_Share_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link copied`)
};

const id_rd_share_done = /** @type {(inputs: Rd_Share_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tautan tersalin`)
};

/**
* | output |
* | --- |
* | "Link copied" |
*
* @param {Rd_Share_DoneInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_share_done = /** @type {((inputs?: Rd_Share_DoneInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Share_DoneInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_share_done(inputs)
	return en_rd_share_done(inputs)
});